/**
 * OCHAT: composer choices that differ from upstream.
 *
 * A flag rather than a deletion: Ochat used to strip useCaptain, useTrack,
 * CAPTAIN_EVENTS and the whole CopilotMenuBar out of ReplyTopPanel.vue. Chatwoot
 * is investing heavily in Captain, so every release re-added parts of it and the
 * conflict had to be re-resolved by hand -- and a bad resolution would bring the
 * Copilot back with no compile error to warn anyone.
 */
export const OCHAT_COMPOSER = {
  /**
   * Hide upstream's Copilot button in the reply top panel. Captain is not part of
   * the Ochat offering and is hidden from the sidebar too, so leaving its entry
   * point in the composer would be inconsistent.
   *
   * The in-editor Copilot menu (Editor.vue) is untouched: that is where the
   * summary handoff to n8n lives.
   */
  hideTopPanelCopilot: true,
};

export default OCHAT_COMPOSER;
